import { typedGql } from '../../../__generated__/gql/zeus/typedDocumentNode.ts';

export const subscription = typedGql('subscription');
